import React from "react";

const Loading = () => (
  <div className="loader">
    <img className="loader-image" src="/images/loader.gif" alt="loader" />
  </div>
);

export default Loading;
